import React, { useEffect, useState } from "react";
import { Form, Input, Button } from "antd";
import "./Verification.css";
import Index from "../Index";
import VerificationInput from "react-verification-input";
import { useDispatch, useSelector } from "react-redux";
import { VerificationActionHandler } from "../../Redux/Actions/common/Verification";
import { useNavigate } from "react-router-dom";

const Verification = () => {
  const mainLogo = "/assets/QA_Logo.svg";
  let dispatch = useDispatch();
  let Navigate = useNavigate();
  const [verificationValue, setVerificationValue] = useState("");

  const verificationdata = useSelector(
    (state) => state?.VerificationData?.Verification_data
  );
  const handleVerificationChange = (value) => {
    setVerificationValue(value);
  };

  useEffect(() => {
    if (verificationdata) {
      Navigate("/login");
    }
    // eslint-disable-next-line
  }, [verificationdata]);
  const onFinish = (value) => {
    let data = {
      email: value?.email,
      code: verificationValue,
    };
    dispatch(VerificationActionHandler(data));

    //gtm
    window.dataLayer.push({
      event: "Verification",
      buttonName: "Verification",
      userId: JSON.parse(localStorage.getItem("userDetails"))?.id,
      clientId: JSON.parse(localStorage.getItem("userDetails"))?.client_id,
    });
  };
  return (
    <>
      <div className="verification-container">
        <Index />
        {/* {contextHolder} */}
        <div className="verification-main auth-custom-scrollbar">
          <div className="verification-div">
            <div className="center-img">
              <img src={mainLogo} alt="" className="centered-image" />
            </div>

            <p className="verification_text">Verification</p>
            <p className="verification_midtext">
              A verification code has been sent to your email. This code will be
              valid for 15 minutes.
            </p>
            <Form
              name="verification"
              initialValues={{ email: "", code: "" }}
              onFinish={onFinish}
              className="verification-class-form"
            >
              <label>Your email</label>
              <Form.Item
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Please input your email!",
                  },
                  {
                    type: "email",
                    message: "Please enter a valid email address",
                  },
                ]}
              >
                <Input
                  placeholder="Enter your email"
                  addonAfter={
                    <span className="verification_edit_email">
                      Edit your email
                    </span>
                  }
                />
              </Form.Item>

              <div className="Verification_input">
                <VerificationInput
                  validChars="0-9"
                  value={verificationValue}
                  placeholder=""
                  onChange={handleVerificationChange}
                />
              </div>
              <div className="Verification_input_resend">
                <div className="registarion-varifty-second-resend">
                  <span>If you didn’t receive a code,</span>{" "}
                  <label>Resend</label>
                </div>
              </div>
              <Form.Item>
                <Button
                  style={{ marginTop: "30px" }}
                  type="primary"
                  htmlType="submit"
                  block
                  className="submit_login-btn"
                >
                  Next
                  {/* Verify & Register */}
                </Button>
              </Form.Item>

              <div className="registarion-varifty-second">
                Wait 16 seconds before requesting a new code
              </div>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Verification;
